//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as Sentry from '@sentry/browser'
import { AUTH_LOGOUT } from '@/store/modules/auth/actions'
import { USER_STOP_MASQUERADING_REQUEST } from '@/store/modules/user/actions'

export default {
  name: 'AccountMenu',

  data() {
    return {
      masqueradeLoading: false
    }
  },

  methods: {
    loadProfilePage() {
      this.$router.push('/profile').catch(() => {})
    },
    loadDeveloperPage() {
      this.$store.dispatch('notify', {
        message: 'Opening the developers page',
        type: 'info'
      })
    },
    loadAccountsPage() {
      this.$router.push('/account')
    },
    loadHelpPage() {
      this.$store.dispatch('notify', {
        message: 'Opening the help page',
        type: 'info'
      })
    },
    doLogout() {
      this.masqueradeLoading = true
      this.$store
        .dispatch(AUTH_LOGOUT)
        .then(() => {
          this.masqueradeLoading = false
          this.$router.push('/login')
        })
        .catch(error => {
          Sentry.captureException(error)
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.masqueradeLoading = false
          this.$router.push('/login')
        })
    },
    doStopMasquerading() {
      this.masqueradeLoading = true
      this.$store
        .dispatch(USER_STOP_MASQUERADING_REQUEST)
        .then(() => {
          this.masqueradeLoading = false
        })
        .catch(error => {
          Sentry.captureException(error)
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.masqueradeLoading = false
        })
    }
  }
}
